export default __webpack_public_path__ + "static/ProValue_6@992-8bb2c5a58dde823bab92de6f980047b6.webp";